export default __webpack_public_path__ + "static/media/suppliers2.8edd4ad7.jpeg";